import { Observable, from } from 'rxjs';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import {
  ROUTES_WITH_RECAPTCHA_VALIDATION,
} from '@common/constants/recaptcha.constants';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class RecaptchaInterceptor implements HttpInterceptor {

  constructor(
    public router: Router,
    private recaptchaService: ReCaptchaV3Service,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (isPlatformBrowser(this.platformId)) {
      const matches = ROUTES_WITH_RECAPTCHA_VALIDATION.filter(
        (routes) => this.compareStringUsingWildcard(routes.route, request.url) && routes.method === request.method
      );
      if (matches.length === 1) {
        return from(this.getRecaptchaToken(matches[0].action))
        .pipe(
          switchMap((recaptchaToken: string) => {
            const requestClone = this.updateCaptcha(request, recaptchaToken);
            return next.handle(requestClone);
          })
        );
      }
      return next.handle(request);
    }
    return next.handle(request);
  }

  private getRecaptchaToken(actionKey: string) {
    return this.recaptchaService.execute(actionKey);
  }

  private updateCaptcha(request: HttpRequest<any>, recaptchaToken: string) {
    let headers = request.headers;
    headers = headers.append('Recaptcha-Token', recaptchaToken);
    return request.clone({ headers });
  }

  private compareStringUsingWildcard(template: string, stringToCompare: string): boolean {
    return new RegExp('^' + template.replace(/\*/g, '.*') + '$').test(stringToCompare);
  }
}
